/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponse
 */
export interface FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponse {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponse
     */
    DownloadUri: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponse interface.
 */
export function instanceOfFxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponse(value: object): value is FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponse {
    if (!('DownloadUri' in value) || value['DownloadUri'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponseFromJSON(json: any): FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponse {
    return FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponseFromJSONTyped(json, false);
}

export function FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'DownloadUri': json['DownloadUri'],
    };
}

export function FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponseToJSON(json: any): FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponse {
    return FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponseToJSONTyped(json, false);
}

export function FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponseToJSONTyped(value?: FxIdWebFeaturesFtlIntegrationLauncherDownloadRequestResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'DownloadUri': value['DownloadUri'],
    };
}

